var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_7351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1324 0H2.86765C1.27941 0 0 1.30283 0 2.92013V51.0799C0 52.6972 1.27941 54 2.86765 54H45.1324C46.7206 54 48 52.6972 48 51.0799V2.92013C48 1.30283 46.7206 0 45.1324 0ZM2.86765 2.24626H45.1324C45.5074 2.24626 45.7941 2.53827 45.7941 2.92013V17.5882H2.20588V2.92013C2.20588 2.53827 2.49265 2.24626 2.86765 2.24626ZM45.7941 19.8344V34.1656H2.20588V19.8344H45.7941ZM45.1324 51.7537H2.86765C2.49265 51.7537 2.20588 51.4617 2.20588 51.0799V36.4118H45.7941V51.0799C45.7941 51.4617 45.5074 51.7537 45.1324 51.7537Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9619 8.49084H7.85156V10.7371H19.9619V8.49084Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9619 25.8769H7.85156V28.1231H19.9619V25.8769Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9619 43.2629H7.85156V45.5091H19.9619V43.2629Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8209 12.2025C39.2318 11.8628 40.1052 10.4229 39.7717 8.98617C39.4381 7.54948 38.0241 6.66013 36.6132 6.99975C35.2023 7.33937 34.329 8.77935 34.6625 10.216C34.996 11.6527 36.4101 12.5421 37.8209 12.2025Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.622 29.657C39.0531 29.421 40.0253 28.0483 39.7936 26.591C39.5618 25.1337 38.2137 24.1437 36.7826 24.3797C35.3515 24.6157 34.3793 25.9884 34.6111 27.4457C34.8429 28.903 36.1909 29.893 37.622 29.657Z",
    fill: "#D27B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.644 45.4224C40.1988 44.0585 39.5627 42.4948 38.2233 41.9299C36.8839 41.3649 35.3484 42.0126 34.7936 43.3765C34.2388 44.7404 34.8749 46.3041 36.2142 46.869C37.5536 47.4339 39.0892 46.7863 39.644 45.4224Z",
    fill: "#D27B24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_7351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstance);
export default __webpack_public_path__ + "static/media/instance.da2dd758e7baa38de479d82a1c63cf85.svg";
export { ForwardRef as ReactComponent };